module.exports = __webpack_public_path__ + "img/banzu60.9c031d77.png";